/**
 * Utilidades de codificación base64 <-> Uint8Array para mensajes CRDT del WebSocket.
 * Usado por el CollaborativeEditor (Yjs) para serializar updates binarios.
 */

export function uint8ArrayToBase64(uint8Array: Uint8Array): string {
  let binary = "";
  const len = uint8Array.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(uint8Array[i]);
  }
  return window.btoa(binary);
}

export function base64ToUint8Array(base64: string): Uint8Array {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

export function applyTextDiff(
  ytext: { delete: (idx: number, len: number) => void; insert: (idx: number, str: string) => void },
  oldText: string,
  newText: string,
) {
  let start = 0;
  while (start < oldText.length && start < newText.length && oldText[start] === newText[start]) {
    start++;
  }

  let oldEnd = oldText.length;
  let newEnd = newText.length;
  while (oldEnd > start && newEnd > start && oldText[oldEnd - 1] === newText[newEnd - 1]) {
    oldEnd--;
    newEnd--;
  }

  if (oldEnd > start) {
    ytext.delete(start, oldEnd - start);
  }
  if (newEnd > start) {
    ytext.insert(start, newText.slice(start, newEnd));
  }
}
